import angular from 'angular';
import {
  loaderService,
  ssDialogService,
} from 'app/services';
import editPmDocumentDialog from '../dialog.editDocumentDialog';
import controller from './document-schema-changed-dialog.controller';
import template from './document-schema-changed-dialog.html';

class dialogService {
  getOptions($event, {
    document,
    settings,
    deletedSections,
    addedSections,
  }) {
    return {
      controller,
      controllerAs: 'documentSchemaChangedDialogVM',
      locals: {
        document,
        settings,
        deletedSections,
        addedSections,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.documentSchemaChangedDialog', [
  loaderService,
  ssDialogService,
  editPmDocumentDialog
])
  .service('documentSchemaChangedDialog', dialogService)
  .name;
